<template>
  <div class="app-error-image tw-flex tw-justify-center tw-items-center">
    <AppIcon shape="picture" size="16" color="secondary" />
  </div>
</template>

<style lang="scss" scoped>
.app-error-image {
  @apply tw-h-56 tw-w-56 tw-bg-gray-100;
}
</style>
